var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;// iterate locals
;(function(){
  var $$obj = locals;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
pug_html = pug_html + "\u003Cfieldset class=\"col-xs-12\" data-list-item=\"phone\"\u003E";
// iterate item
;(function(){
  var $$obj = item;
  if ('number' == typeof $$obj.length) {
      for (var property = 0, $$l = $$obj.length; property < $$l; property++) {
        var value = $$obj[property];
pug_html = pug_html + "\u003Cinput" + (" type=\"hidden\""+pug.attr("name", `employees[${index}][${property}]`, true, true)+pug.attr("value", (typeof value === 'boolean' ? value.toString() : value), true, true)) + "\u003E";
      }
  } else {
    var $$l = 0;
    for (var property in $$obj) {
      $$l++;
      var value = $$obj[property];
pug_html = pug_html + "\u003Cinput" + (" type=\"hidden\""+pug.attr("name", `employees[${index}][${property}]`, true, true)+pug.attr("value", (typeof value === 'boolean' ? value.toString() : value), true, true)) + "\u003E";
    }
  }
}).call(this);

if (item.phone) {
pug_html = pug_html + "\u003Cdiv class=\"col-xs-12 info-box\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 info-text\"\u003E\u003Cstrong\u003ENome:\u003C\u002Fstrong\u003E\u003Cspan\u003E " + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 info-text\"\u003E\u003Cstrong\u003ETelefone:\u003C\u002Fstrong\u003E\u003Cspan\u003E " + (pug.escape(null == (pug_interp = item.phone) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 info-text\"\u003E";
if (item.default === 'true' || index === 0) {
pug_html = pug_html + "Telefone principal";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-5\"\u003E\u003Cbutton class=\"button button-neutral\" type=\"button\" data-trigger=\"modal\"\u003EEditar\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (locals.length > 1) {
pug_html = pug_html + "\u003Cdiv class=\"col-xs-7 align-right\"\u003E\u003Cbutton class=\"button button-text\" type=\"button\" data-trigger=\"remove\"\u003E\u003Ci class=\"glyph glyph-trash-can\"\u003E\u003C\u002Fi\u003ERemover Telefone\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Ffieldset\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
pug_html = pug_html + "\u003Cfieldset class=\"col-xs-12\" data-list-item=\"phone\"\u003E";
// iterate item
;(function(){
  var $$obj = item;
  if ('number' == typeof $$obj.length) {
      for (var property = 0, $$l = $$obj.length; property < $$l; property++) {
        var value = $$obj[property];
pug_html = pug_html + "\u003Cinput" + (" type=\"hidden\""+pug.attr("name", `employees[${index}][${property}]`, true, true)+pug.attr("value", (typeof value === 'boolean' ? value.toString() : value), true, true)) + "\u003E";
      }
  } else {
    var $$l = 0;
    for (var property in $$obj) {
      $$l++;
      var value = $$obj[property];
pug_html = pug_html + "\u003Cinput" + (" type=\"hidden\""+pug.attr("name", `employees[${index}][${property}]`, true, true)+pug.attr("value", (typeof value === 'boolean' ? value.toString() : value), true, true)) + "\u003E";
    }
  }
}).call(this);

if (item.phone) {
pug_html = pug_html + "\u003Cdiv class=\"col-xs-12 info-box\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 info-text\"\u003E\u003Cstrong\u003ENome:\u003C\u002Fstrong\u003E\u003Cspan\u003E " + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 info-text\"\u003E\u003Cstrong\u003ETelefone:\u003C\u002Fstrong\u003E\u003Cspan\u003E " + (pug.escape(null == (pug_interp = item.phone) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 info-text\"\u003E";
if (item.default === 'true' || index === 0) {
pug_html = pug_html + "Telefone principal";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-5\"\u003E\u003Cbutton class=\"button button-neutral\" type=\"button\" data-trigger=\"modal\"\u003EEditar\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (locals.length > 1) {
pug_html = pug_html + "\u003Cdiv class=\"col-xs-7 align-right\"\u003E\u003Cbutton class=\"button button-text\" type=\"button\" data-trigger=\"remove\"\u003E\u003Ci class=\"glyph glyph-trash-can\"\u003E\u003C\u002Fi\u003ERemover Telefone\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Ffieldset\u003E";
    }
  }
}).call(this);
;return pug_html;};
module.exports = template;